import api from '../config/api';
import {
  FETCH_BALANCE_LOADING,
  FETCH_BALANCE_SUCCESS,
  FETCH_BALANCE_ERROR
} from '../Types/wfhBalanceTypes';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchBalanceHistory = (start, end, page, limit, filters = {}) => {
  return dispatch => {
    dispatch({
      type: FETCH_BALANCE_LOADING
    });

    const queryParams = new URLSearchParams();
    if (page) queryParams.append('page', page);
    if (limit) queryParams.append('limit', limit);
    if (filters.userId) queryParams.append('userId', filters.userId);
    if (filters.operationOwnerId) queryParams.append('operationOwnerId', filters.operationOwnerId);
    if (filters.authorizedDays && filters.authorizedDays.length > 0) {
      filters.authorizedDays.forEach(day => queryParams.append('authorizedDays', day));
    }
    if (filters.transactionType) queryParams.append('transactionType', filters.transactionType);

    const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
    api
      .get(`${API_URL}HistoryBalance/getHistoryBalanceByDate/${start}/${end}${query}`)
      .then(response => {
        dispatch({
          type: FETCH_BALANCE_SUCCESS,
          payload: response.data.data
        });
      })
      .catch(error => {
        dispatch({
          type: FETCH_BALANCE_ERROR,
          payload: error.message
        });
      });
  };
};

export const fetchBalanceSuccess = data => {
  return {
    type: FETCH_BALANCE_SUCCESS,
    payload: data
  };
};

export const fetchBalanceError = error => {
  return {
    type: FETCH_BALANCE_ERROR,
    payload: error
  };
};
